import apiClient from "../common/apiClient";

export default class DepartmentController {
  async Create(data, token) {
    try {
      return await apiClient.post("/department", data, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      return error;
    }
  }

  async Update(departmentId, data, token) {
    try {
      return await apiClient.put("/department/" + departmentId, data, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      return error;
    }
  }

  async Delete(id, token) {
    try {
      return await apiClient.delete("/department/" + id, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      return error;
    }
  }

  async GetAllDepartment(token) {
    try {
      return await apiClient.get("/getAllDepartment", {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      return error;
    }
  }
  async GetDepartmentOptions(token) {
    try {
      return await apiClient.get("/getDepartmentOptions", {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      return error;
    }
  }
}
